import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { useAPIProvider } from '../../../../../common/hooks/use-api-provider';
import { useQuestionnairePrefetch } from '../../../../../index';
import { annotationLabelsAtom } from '../../../atoms/annotation-atoms';
export const useSidePanelQuestionnairePrefetch = () => {
  const annotationLabels = useAtomValue(annotationLabelsAtom);
  const {
    fetchQuestionnaire
  } = useAPIProvider();
  const questionnaireIds = useMemo(() => {
    return annotationLabels.flatMap(label => label.questionnaire?.map(questionnaire => questionnaire.questionnaireId)).filter(questionnaireId => questionnaireId !== undefined);
  }, [annotationLabels]);
  useQuestionnairePrefetch({
    questionnaireIds,
    fetchQuestionnaire
  });
};